import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { FormControlState } from 'ngrx-forms';
import { Constants } from '../../utils/constants';

@Component({
  standalone: false,
  selector: 'app-input-container',
  templateUrl: './input-container.component.html',
  styleUrls: ['./input-container.component.scss'],
  host: {
    class: 'input-container',
  },
})
export class InputContainerComponent {
  @Input() label!: string;
  @Input() labelFor!: string;
  @Input() boldLabel: boolean = false;
  @Input() isRequired!: boolean;
  @Input() characterCounterLength!: number;
  @Input() characterCounterMaxLength!: number;
  @Input() info!: string;
  @Input() referenceInfo!: string;
  @Input() referenceUrl!: string;
  @Input('app-input-validation-container')
  inputValidationContainer!: FormControlState<any>;
  @Input() copy: boolean = false;
  @Output() copyEvent: EventEmitter<void> = new EventEmitter();
  @Input() extraLabelTemplateRef?: TemplateRef<any>;

  REQUIRED_MAPPING_ERROR = Constants.REQUIRED_MAPPING_ERROR;
}
